// ============================================================================
// हिंदी अनुवाद - यीशु नहीं हैं...
// ============================================================================
// यीशु वास्तव में कौन हैं, इसके बारे में महत्वपूर्ण स्पष्टीकरण

export const jesusIsNot = [
  {
    "category": "प्रेम",
    "text": "यीशु समलैंगिक-विरोधी नहीं हैं - उनका अनंत प्रेम सभी को जैसे वे हैं, शामिल करता है",
    "reference": "1 यूहन्ना 4:8 - परमेश्वर प्रेम है",
    "context": "परमेश्वर का प्रेम समावेशी है और प्रत्येक व्यक्ति को उनकी विविधता में स्वीकार करता है"
  },
  {
    "category": "समानता",
    "text": "यीशु स्त्री-द्वेषी नहीं हैं - उनका अनंत प्रेम हर महिला को महत्व देता है",
    "reference": "लूका 8:1-3 - यीशु का अनुसरण करने वाली महिलाएं",
    "context": "यीशु महिलाओं को शामिल करके और सम्मान देकर अपने समय में क्रांति लाते हैं"
  },
  {
    "category": "शांति",
    "text": "यीशु हत्यारे नहीं हैं - उनका अनंत प्रेम सभी को जीवन देता है",
    "reference": "यूहन्ना 10:10 - मैं इसलिए आया कि वे जीवन पाएं",
    "context": "यीशु सभी को जीवन, उपचार और पुनर्स्थापना लाते हैं"
  },
  {
    "category": "एकता",
    "text": "यीशु विभाजनकारी नहीं हैं - उनका अनंत प्रेम पूरी मानवता को एकजुट करता है",
    "reference": "गलातियों 3:28 - न यहूदी रहा न यूनानी",
    "context": "यीशु का प्रेम सभी मानवीय बाधाओं को पार करता है"
  },
  {
    "category": "प्रेम",
    "text": "यीशु नस्लवादी नहीं हैं - उनका अनंत प्रेम सभी संस्कृतियों को अपनाता है",
    "reference": "मत्ती 28:19 - सब जातियों को चेला बनाओ",
    "context": "यीशु का प्रेम पूरी मानवता की विविधता का जश्न मनाता है"
  },
  {
    "category": "न्याय",
    "text": "यीशु अत्याचारी नहीं हैं - उनका अनंत प्रेम सभी को मुक्त और चंगा करता है",
    "reference": "लूका 4:18 - उसने मुझे बन्धुओं को छुटकारा प्रचार करने भेजा है",
    "context": "यीशु का प्रेम सभी को स्वतंत्रता और उपचार लाता है"
  },
  {
    "category": "विनम्रता",
    "text": "यीशु अभिमानी नहीं हैं - उनका अनंत प्रेम सभी की सेवा करता है",
    "reference": "फिलिप्पियों 2:7 - उसने अपने आप को खाली कर दिया",
    "context": "यीशु का प्रेम विनम्रता और सेवा के माध्यम से व्यक्त होता है"
  },
  {
    "category": "क्षमा",
    "text": "यीशु प्रतिशोधी नहीं हैं - उनका अनंत प्रेम हमेशा क्षमा करता है",
    "reference": "लूका 23:34 - हे पिता, इन्हें क्षमा कर, क्योंकि ये जानते नहीं कि क्या कर रहे हैं",
    "context": "यीशु का प्रेम कष्ट में भी क्षमा प्रदान करता है"
  },
  {
    "category": "करुणा",
    "text": "यीशु असंवेदनशील नहीं हैं - उनका अनंत प्रेम हर दर्द को महसूस करता है",
    "reference": "यूहन्ना 11:35 - यीशु रोया",
    "context": "यीशु का प्रेम हमारी खुशियों और दुखों को गहराई से साझा करता है"
  },
  {
    "category": "सत्य",
    "text": "यीशु झूठे नहीं हैं - उनका अनंत प्रेम शुद्ध सत्य है",
    "reference": "यूहन्ना 14:6 - मार्ग और सत्य और जीवन मैं ही हूं",
    "context": "यीशु का प्रेम सबसे प्रामाणिक सत्य है जो मौजूद है"
  },
  {
    "category": "शांति",
    "text": "यीशु हिंसक नहीं हैं - उनका अनंत प्रेम सच्ची शांति लाता है",
    "reference": "मत्ती 5:9 - धन्य हैं वे जो मेल करवाते हैं",
    "context": "यीशु का प्रेम संघर्षों को सुलह में बदल देता है"
  },
  {
    "category": "उदारता",
    "text": "यीशु कंजूस नहीं हैं - उनका अनंत प्रेम बिना माप के देता है",
    "reference": "2 कुरिन्थियों 8:9 - तुम्हारे लिए वह कंगाल हो गया",
    "context": "यीशु का प्रेम सब कुछ देने तक उदार है"
  },
  {
    "category": "प्रेम",
    "text": "यीशु पक्षपाती नहीं हैं - उनका अनंत प्रेम हर अद्वितीय प्राणी का स्वागत करता है",
    "reference": "प्रेरितों 10:34 - परमेश्वर किसी का पक्षपात नहीं करता",
    "context": "यीशु का प्रेम विकलांगता सहित प्रत्येक व्यक्ति की विशिष्टता का जश्न मनाता है"
  },
  {
    "category": "सार्वभौमिकता",
    "text": "यीशु की कोई सीमा नहीं है - उनका अनंत प्रेम सभी सीमाओं को पार करता है",
    "reference": "रोमियों 10:12 - यहूदी और यूनानी में कोई अन्तर नहीं",
    "context": "यीशु के लिए कोई सीमा नहीं है: न भौगोलिक, न सांस्कृतिक, न सामाजिक"
  },
  {
    "category": "सम्मान",
    "text": "यीशु अपमानजनक नहीं हैं - वे आत्म-सम्मान, महिलाओं का सम्मान, दूसरों का सम्मान सिखाते हैं",
    "reference": "मत्ती 22:39 - अपने पड़ोसी से अपने समान प्रेम रखना",
    "context": "सम्मान निश्चित ज्ञान है: अपने जीवन, अपने शरीर, महिलाओं को अपने समान, दूसरों का सम्मान करें"
  },
  {
    "category": "शांति",
    "text": "यीशु विभाजनकारी नहीं हैं - वे यहूदियों, अरबों और सभी संप्रदायों को शांति में एकजुट करते हैं",
    "reference": "इफिसियों 2:14 - वही हमारा मेल है, जिसने दोनों को एक कर दिया",
    "context": "आइए हम अपनी विविधता का जश्न मनाएं बजाय इसे शब्द-युद्ध और युद्ध बनाने के"
  },
  {
    "category": "सत्य",
    "text": "यीशु झूठे नहीं हैं - वे झूठ और हेरफेर का पर्दाफाश करते हैं",
    "reference": "यूहन्ना 8:44 - शैतान झूठ का पिता है",
    "context": "यीशु उन झूठों और हेरफेरों को उजागर करते हैं जो आत्माओं को घायल करते हैं"
  },
  {
    "category": "उदारता",
    "text": "यीशु लालची नहीं हैं - उनकी उदारता दशमांश से कहीं अधिक है",
    "reference": "लूका 21:3 - इस गरीब विधवा ने सबसे अधिक डाला है",
    "context": "यीशु की उदारता दशमांश के दायित्व से अधिक मजबूत है"
  },
  {
    "category": "न्याय",
    "text": "यीशु मौन के सहयोगी नहीं हैं - वे स्वस्थ न्याय के माध्यम से सुरक्षा करते हैं",
    "reference": "मत्ती 18:6 - जो कोई इन छोटों में से किसी एक को ठोकर खिलाए",
    "context": "मौन जो दूसरों की रक्षा किए बिना दोषों को ढकता है, यीशु का ज्ञान नहीं है"
  }
];

export default jesusIsNot;
